'use es6';

import styled from 'foundations-theming/utils';
import UIMultiLevelDropdown from 'UIComponents/dropdown/UIMultiLevelDropdown';
export default styled(UIMultiLevelDropdown).withConfig({
  displayName: "StyleProtectedUIMultiLevelDropdown",
  componentId: "k8fuai-0"
})(["display:block !important;& button{color:", " !important;background-color:", " !important;&:hover{background-color:", " !important;}}"], ({
  theme
}) => theme.color['do-not-use-obsidian'], ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => theme.color['do-not-use-calypso-light']);